var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.308 19.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283V6.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h15.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v11.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H4.308zM20 7.442l-7.514 4.81a1.18 1.18 0 01-.238.103.848.848 0 01-.496 0 1.18 1.18 0 01-.239-.103L4 7.442v10.25a.3.3 0 00.087.221.3.3 0 00.22.087h15.385a.3.3 0 00.221-.087.3.3 0 00.087-.22V7.442zM12 11l7.846-5H4.154L12 11zM4 7.673V6.53v.03-.032 1.145z",
    fill: "currentColor"
  })));
}
SvgMail.displayName = 'Mail';
export default SvgMail;